module.exports = __webpack_public_path__ + "static/media/piecelight.d03a064f.svg";